export default "__VITE_ASSET__69WMtnYB__"